export default function getModality(item) {
  if (item.industry.is_mercapromo) {
    if (item.types[0] === 'benefits' || item.types[0] === 'benefits_offer_sales') {
      return {
        color: '#CE970A',
        text: 'Zé Delivery',
      }
    } else {
      return {
        color: '#C3008C',
        text: 'Mercapromo',
      }
    }
  }
  return {
    color: '#5B0A9B',
    text: 'Mercatrade',
  }
}
